import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {$accountFactory} from "../../$account.factory";
import {AccountModel} from "../../angular/models/account.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class AccountsValidationTableRow implements IController {
  account: AccountModel;
  accountId: any;
  onToggle: any;
  onRemove: any;
  onEdit: Function;

  private readonly siteLabels: any;
  private errorFields: any;

  /* @ngInject */
  constructor(private $account: $accountFactory, private splitService: SplitService) {
    this.siteLabels = this.splitService.getSiteLabels();
  }

  $onInit() {
    this.errorFields = [];
    this.errorFields = _.map(this.account.mappingErrors, (error) => {
      return error.fieldName;
    });
  }

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getErrorDescriptions() {
    return _.map(this.account.mappingErrors, 'description');
  }

  isMissing(type, name) {
    var stringName = 'account.' + _.toLower(type) + '.' + name;
    var matchedError = _.find(this.errorFields, (e) => {
      return _.includes(e, stringName);
    });

    return !_.isUndefined(matchedError);
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountsValidationTableRow', {
    require: {
      accountsValidationTableCtrl: '^accountsValidationTable'
    },
    bindings: {
      account: '<',
      accountId: '<',
      onToggle: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./accounts-validation-table-row.html').default,
    controller: AccountsValidationTableRow
  });
